// NOTE: NSAI-5752 — in-app reporting of AI output and of user-published catalog
// content, required by Google Play's AI-Generated Content policy and Apple's
// Guideline 1.2. Shared so web, mobile and the browser extension speak one
// contract and offer the same reason set.

// NOTE: NSAI-6374 extended this from two surfaces to seven. The clients treat
// them uniformly — pick a kind, send a uuid — but the server does not: MEETING
// is stored in its own table, because a meeting belongs to a person rather than
// to a project or an organization. Nothing here has to know that.
export enum EContentReportTargetKind {
  MESSAGE = "message",
  CATALOG_ENTRY = "catalog_entry",
  MESSAGE_FILE = "message_file",
  CRON_RUN = "cron_run",
  WEBHOOK_RUN = "webhook_run",
  HOOK_RUN = "hook_run",
  MEETING = "meeting",
}

// NOTE: Kept deliberately short. A long picker turns reporting into a quiz and
// pushes people into "other"; these five cover what both stores ask about, and
// OTHER carries the free text for everything else.
export enum EContentReportReason {
  HARMFUL_OR_UNSAFE = "harmful_or_unsafe",
  OFFENSIVE = "offensive",
  INACCURATE = "inaccurate",
  PRIVACY_CONCERN = "privacy_concern",
  OTHER = "other",
}

// NOTE: Render order for the reason picker, shared so the options appear in the
// same order on every platform. Severity first: the reasons a moderator must act
// on outrank the ones that are feedback about quality.
export const CONTENT_REPORT_REASONS = [
  EContentReportReason.HARMFUL_OR_UNSAFE,
  EContentReportReason.OFFENSIVE,
  EContentReportReason.PRIVACY_CONCERN,
  EContentReportReason.INACCURATE,
  EContentReportReason.OTHER,
] as const;

// NOTE: Matches CONTENT_REPORT_DETAILS_MAX_LENGTH on the server. Duplicated
// rather than imported because the server is not a dependency of the clients;
// the client cap exists to show a counter, the server's is the real guard.
export const CONTENT_REPORT_DETAILS_MAX_LENGTH = 1000;

// NOTE: Machine-readable codes the server returns so a client can tell "you
// already reported this" apart from a real failure without parsing a localized
// message.
export const CONTENT_REPORT_ERROR_CODES = {
  TARGET_NOT_FOUND: "CONTENT_REPORT_TARGET_NOT_FOUND",
  ALREADY_REPORTED: "CONTENT_REPORT_ALREADY_REPORTED",
  NOT_REPORTABLE: "CONTENT_REPORT_NOT_REPORTABLE",
} as const;

export interface ICreateContentReportPayload {
  targetKind: EContentReportTargetKind;
  targetUuid: string;
  reason: EContentReportReason;
  details?: string | null;
}

export interface IContentReportResponse {
  uuid: string;
  targetKind: EContentReportTargetKind;
  reason: EContentReportReason;
  createdAt: string;
}
